export const EVENTS:{[key:string]:string} = {
    SORTING: "sorting",
    ADD_ROWS: "add-rows",
    REMOVE_ROWS: "remove-rows",
    PAGE_SIZE_CHANGED:"page-size-changed"
}